export default "__VITE_ASSET__ad724d94__"